import { HEADER_HEIGHT_IN_PIXELS } from 'src/molecules/Shared/2023_Q4/Header/Header.styles';
import styled, { css } from 'styled-components';

export const SCALE_RESOLUTION_COEFFICIENT = 0.0006;

export const StyledCompensatedHeaderHeight = styled.div`
  box-sizing: border-box;
  padding-top: ${HEADER_HEIGHT_IN_PIXELS}px;
  position: relative;
  width: 100vw;
  height: 100vh;
`;

export interface StyledContainerWithScaleProps {
  currentScale?: number;
  scaleOrigin?: 'center' | 'top' | 'left' | 'right' | 'bottom';
}

const scaleStyles = css<StyledContainerWithScaleProps>`
  transform: scale(${({ currentScale }) => currentScale ?? 1});
  transform-origin: ${({ scaleOrigin }) => scaleOrigin ?? 'center'};
`;

export const StyledCompensatedHeaderHeightWithScale = styled(
  StyledCompensatedHeaderHeight
)<StyledContainerWithScaleProps>`
  ${scaleStyles}
`;

export const StyledContainerWithScale = styled.div<StyledContainerWithScaleProps>`
  ${scaleStyles}
`;

export const getSectionScaleValueByWindowWidth = (
  windowWidth: number,
  windowHeight: number,
  customResolutionCoefficient?: number
): number => {
  // The section is created to fit 1440px width screens, so when the screen is wider then FHD (1920px)
  // we need to scale the section to fit the screen width properly, so it doesn't affect the experience
  const aspectRatio = windowWidth / windowHeight;
  const baseAspectRatio = 1440 / 900;

  const aspectRatioBasedScale = Math.min(baseAspectRatio / aspectRatio, 1);

  if (windowWidth >= 1600) {
    const widthBasedScale = windowWidth * (customResolutionCoefficient ?? SCALE_RESOLUTION_COEFFICIENT);

    return Math.round(widthBasedScale * aspectRatioBasedScale * 100) / 100;
  }

  return aspectRatioBasedScale;
};
